import React, { useEffect, useState } from 'react'
import debounce from 'lodash/debounce'
import styled from 'styled-components'
import { Container } from '../../assets/styles/GlobalStyle'
import api from '../../api'
import Loader from '../../components/Loader'
import { useAppSelector } from '../../store'
import Colors from '../../assets/styles/Colors'
import FindAnswerBanner from '../../components/v2/FindAnswerBanner'
import PlayStores from '../../components/PlayStores'
import Responsive from '../../assets/config/Responsive'
import SmallArrow from '../../assets/icons/JSX/SmallArrow'
import { useTranslation } from 'react-i18next'
import RichText from '../../components/v2/RichText'
import { AppState } from '../../store/appSlice'

const OurPartners = () => {
  //
  const { t } = useTranslation()
  //
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = debounce(() => setScreenWidth(window.innerWidth), 100)

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  //
  const [openedAccIndex, setOpenedAccIndex] = useState<number | null>(null)
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { data: mainpageTextList, isLoading: isMainPageTextLoading } = api.useGetMainPageTextListQuery(undefined)
  //
  const { data: partners, isLoading } = api.useGetFraniPartnersQuery(undefined)
  //
  const MainLoading = isMainPageTextLoading || isLoading
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Container>
        <Title>{t('ourPartners')}</Title>
        <Contetn>
          {partners &&
            partners.map((item, index) => (
              <Card key={index}>
                <AccButton
                  onClick={() => {
                    if (openedAccIndex === index) {
                      setOpenedAccIndex(null)
                    } else {
                      setOpenedAccIndex(index)
                    }
                  }}
                >
                  <SmallArrowStyle
                    style={{
                      transform: openedAccIndex === index ? 'rotate(0deg)' : 'rotate(180deg)',
                      fill: openedAccIndex === index ? `${Colors.primaryBlack}` : `${Colors.nevadaGrey}`,
                    }}
                  />
                </AccButton>
                <Top>
                  <Img src={item?.imageUrl} alt={`company-img-${item.id}`} />
                  <TopTexts>
                    <Name>{item?.translations?.[lang]?.title}</Name>
                    {screenWidth > 1199 ? (
                      <ShortDescription>
                        <RichText html={item.translations?.[lang]?.body || ''} />
                      </ShortDescription>
                    ) : null}
                  </TopTexts>
                </Top>
                {(screenWidth <= 1199 && openedAccIndex === index) || screenWidth > 1199 ? (
                  <Bottom>
                    {screenWidth <= 1199 ? (
                      <>
                        <ShortDescription>
                          <RichText html={item.translations?.[lang]?.body || ''} />
                        </ShortDescription>
                        <hr />
                      </>
                    ) : null}
                    <Description>
                      <RichText html={item?.translations?.[lang]?.secondBody || ''} />
                    </Description>
                    <ATag href={`https://${item.webAddress}` || '#'} target="_black">
                      {item.webAddress}
                    </ATag>
                  </Bottom>
                ) : null}
              </Card>
            ))}
        </Contetn>

        <FindAnswerBanner isFrani={true} />

        <br />

        <DownloadSection>
          <ServiceHead>
            <h1>
              {mainpageTextList?.find((item) => item.slug === 'main-page-fourth-block')?.translations?.[lang]?.title}
            </h1>
            <p>
              {mainpageTextList?.find((item) => item.slug === 'main-page-fourth-block')?.translations?.[lang]?.excerpt}
            </p>
          </ServiceHead>
          <PlayStores />
        </DownloadSection>
        {/*  */}
      </Container>
    </Wrapper>
  )
}
//
const AccButton = styled.button`
  display: none;
  position: absolute;
  top: 20px;
  left: 6px;
  border: unset;
  outline: none;
  background-color: transparent;

  ${Responsive.tablet} {
    display: block;
  }
  ${Responsive.mobile} {
    display: block;
  }
`
const SmallArrowStyle = styled(SmallArrow)`
  width: 10px;
  margin: 10px;
`
const ServiceHead = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 65px;
  position: sticky;
  z-index: 1;
  /* TItle */
  h1 {
    /* font-size: 36px; */
    font-size: 20px;
    color: ${Colors.Black};
    margin-bottom: 35px;
    text-align: center;
  }
  /* description */
  p {
    font-size: 18px;
    color: ${Colors.SilverChalice};
    margin-bottom: 35px;
    width: 50%;
    text-align: center;
  }
  ${Responsive.mobile} {
    margin-bottom: 30px;
    /* TItle */
    h1 {
      font-size: 18px;
      margin-bottom: 16px;
    }
    /* description */
    p {
      font-size: 12px;
      margin-bottom: 0px;
      width: 100%;
    }
  }
`
const DownloadSection = styled.section`
  background-color: ${Colors.white};
  /* z-index: 1; */
  position: sticky;
  padding-top: 85px;
  padding-bottom: 85px;
  overflow-y: hidden;
  user-select: none;
  pointer-events: none;
  ${Responsive.mobile} {
    padding-top: 30px;
    padding-bottom: 40px;
  }
`
const TopTexts = styled.div`
  border-left: 1px solid ${Colors.secondaryGrey};
  padding-left: 24px;
  margin-left: 24px;

  ${Responsive.mobile} {
    border: unset;
    padding-left: 0px;
  }
`
const ATag = styled.a`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  display: block;
  margin-top: 20px;

  &:hover {
    color: ${Colors.nevadaGrey};
  }
`
const Description = styled.p`
  margin-bottom: 0px;
  margin-top: 33px;
  font-size: 14px;
  color: ${Colors.nevadaGrey};

  ${Responsive.tablet} {
    margin-top: 0px;
  }
  ${Responsive.mobile} {
    margin-top: 0px;
  }
`
const ShortDescription = styled.p`
  margin-bottom: 0px;

  ${Responsive.tablet} {
    margin-top: 25px;
  }
  ${Responsive.mobile} {
    margin-top: 25px;
  }
`
const Img = styled.img`
  height: 64px;

  ${Responsive.tablet} {
    height: 52px;
  }

  ${Responsive.mobile} {
    height: 52px;
  }
`
const Name = styled.div`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 2px;
`
const Bottom = styled.div`
  ${Responsive.mobile} {
    margin-top: 25px;
  }
`
const Top = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const Card = styled.div`
  padding: 48px 80px 48px;
  border-radius: 8px;
  box-shadow: 0 4px 50px 0 rgba(0, 0, 0, 0.04);
  background-color: ${Colors.white};
  position: relative;

  ${Responsive.tablet} {
    padding: 24px 38px;
  }
  ${Responsive.mobile} {
    padding: 24px 38px;
  }
`
const Title = styled.h1`
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: ${Colors.primaryBlack};
  margin-bottom: 70px;

  ${Responsive.mobile} {
    font-size: 18px;
    margin-bottom: 30px;
  }
`
const Contetn = styled.div`
  display: grid;
  gap: 32px;
`
const Wrapper = styled.div`
  padding-block: 80px 50px;

  ${Responsive.mobile} {
    padding-block: 32px 50px;
  }
`
//
export default OurPartners
